import React, { useEffect, useState } from 'react'
import AppHeader from '../components/AppHeader'
import ComplaintForm from '../components/ComplaintForm';
import { Link } from 'react-router-dom';
import useSystemMasterList from '../../../hooks/useSystemMasterList';
import UserComplaintList from '../components/UserComplaintList';

function PortalDashboardPage() {

	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	const [customerPhoneNo, setCustomerPhoneNo] = useState(sessionStorage.customerPhoneNo);

	return (
		<>
			<AppHeader/>
			<div className='container'>
				<ComplaintForm masters={masters} />
				<div className='my-4'>
				{customerPhoneNo && customerPhoneNo.length === 10 &&
                	<UserComplaintList masters={masters} getMasterLabel={getMasterLabel} customerPhoneNo={customerPhoneNo} />    
				}
				</div>
			</div>
		</>
  	)
}

export default PortalDashboardPage


/*

import GoogleMapReact from 'google-map-react';
import { PinDrop } from '@mui/icons-material';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

	<div style={{ height: '400px', width: '100%' }}>
		{lat && lng &&
			<GoogleMapReact
			bootstrapURLKeys={{ key: "" }}
			defaultCenter={{lat:lat,lng:lng}}
			defaultZoom={18}
			>
				<AnyReactComponent
					lat={lat}
					lng={lng}
					text={<PinDrop style={{fontSize:22, color:"#F00"}} />}
				/>
			</GoogleMapReact>
		}
    </div>
*/